import { render, staticRenderFns } from "./BulkJobList.vue?vue&type=template&id=320410c2&scoped=true"
import script from "./BulkJobList.vue?vue&type=script&lang=ts"
export * from "./BulkJobList.vue?vue&type=script&lang=ts"
import style0 from "./BulkJobList.vue?vue&type=style&index=0&id=320410c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320410c2",
  null
  
)

export default component.exports